(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trusted-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trusted-customer-reviews')) {
    customElements.define('trusted-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tcr__track');
        this.cards = [...this.querySelectorAll('.tcr__card')];
        this.dots = [...this.querySelectorAll('.tcr__dot')];
        this.arrows = [...this.querySelectorAll('.tcr__arrow')];
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.move = left => this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.arrows.forEach(button => button.addEventListener('click', () => this.move(this.track.scrollLeft + Number(button.dataset.direction) * this.track.clientWidth), options));
        this.dots.forEach(button => button.addEventListener('click', () => this.move(this.positions[Number(button.dataset.index)]), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.reviewId === event.detail.blockId);
          if (card) this.move(card.offsetLeft - this.cards[0].offsetLeft);
        }, options);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.cards.forEach(card => this.observer.observe(card));
        this.measure();
      }
      measure() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const origin = this.cards[0]?.offsetLeft || 0;
        this.positions = [...new Set(this.cards.map(card => Math.min(max, Math.max(0, card.offsetLeft - origin))))];
        this.arrows.forEach(button => { button.hidden = max < 2; });
        this.querySelector('.tcr__dots').hidden = max < 2;
        this.dots.forEach((button, index) => { button.hidden = index >= this.positions.length; });
        this.update();
      }
      update() {
        if (!this.positions?.length) return;
        const left = this.track.scrollLeft;
        const active = this.positions.reduce((best, position, index) => Math.abs(position - left) < Math.abs(this.positions[best] - left) ? index : best, 0);
        const mobile = matchMedia('(max-width: 699px)').matches;
        const firstDot = Math.max(0, Math.min(active - 2, this.positions.length - 5));
        this.dots.forEach((button, index) => {
          button.setAttribute('aria-current', index === active ? 'true' : 'false');
          button.hidden = index >= this.positions.length || (mobile && (index < firstDot || index >= firstDot + 5));
        });
        if (mobile && this.cards[active]) {
          const height = `${Math.ceil(this.cards[active].getBoundingClientRect().height)}px`;
          if (this.track.style.height !== height) this.track.style.height = height;
        } else {
          this.track.style.removeProperty('height');
        }
        this.arrows[0].disabled = left < 2;
        this.arrows[1].disabled = left >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["western-brands-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('western-brands-showcase')) {
    customElements.define('western-brands-showcase', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.western-brands__track');
        this.cards = [...this.querySelectorAll('.western-brands__card')];
        this.dots = [...this.querySelectorAll('.western-brands__dot')];
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.move = (left) => this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.dots.forEach(button => button.addEventListener('click', () => this.move(this.positions[Number(button.dataset.index)]), options));
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('pointerdown', event => {
          if (!matchMedia('(max-width: 699px)').matches || !event.isPrimary || event.button !== 0) return;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, mouse: event.pointerType === 'mouse' };
          this.suppressClick = false;
        }, options);
        window.addEventListener('pointermove', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.id !== event.pointerId) return;
          const distance = event.clientX - gesture.x;
          if (Math.abs(distance) > 10 && Math.abs(distance) > Math.abs(event.clientY - gesture.y)) this.suppressClick = true;
          if (gesture.mouse && this.suppressClick) {
            event.preventDefault();
            this.track.style.scrollSnapType = 'none';
            this.track.scrollLeft = gesture.left - distance;
          }
        }, options);
        const finishGesture = event => {
          if (!this.gesture || this.gesture.id !== event.pointerId) return;
          const mouse = this.gesture.mouse;
          this.gesture = null;
          this.track.style.removeProperty('scroll-snap-type');
          if (mouse && this.suppressClick && this.positions.length) {
            const nearest = this.positions.reduce((best, position) => Math.abs(position - this.track.scrollLeft) < Math.abs(best - this.track.scrollLeft) ? position : best, this.positions[0]);
            this.move(nearest);
          }
        };
        window.addEventListener('pointerup', finishGesture, options);
        window.addEventListener('pointercancel', finishGesture, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.brandId === event.detail.blockId);
          if (card) this.move(card.offsetLeft - this.cards[0].offsetLeft);
        }, options);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.measure();
      }
      measure() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const origin = this.cards[0]?.offsetLeft || 0;
        this.positions = [...new Set(this.cards.map(card => Math.min(max, Math.max(0, card.offsetLeft - origin))))];
        this.querySelector('.western-brands__dots').hidden = this.positions.length === 0 || (max < 2 && !matchMedia('(max-width: 699px)').matches);
        this.dots.forEach((button, index) => { button.hidden = index >= this.positions.length; });
        this.update();
      }
      update() {
        if (!this.positions) return;
        const left = this.track.scrollLeft;
        const active = this.positions.reduce((best, position, index) => Math.abs(position - left) < Math.abs(this.positions[best] - left) ? index : best, 0);
        this.dots.forEach((button, index) => button.setAttribute('aria-current', index === active ? 'true' : 'false'));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
